<div
  [id]="carouselId"
  class="carousel slide"
  [attr.data-bs-ride]="autoCycle ? 'carousel' : null"
  [attr.data-bs-interval]="interval"
>
  <div class="d-flex align-items-center justify-content-between flex-wrap" *ngIf="heading || showIndicators">
    <span class="fs-4 fw-bold pe-2" *ngIf="heading">{{ heading }}</span>

    <ol class="p-0 m-0 carousel-indicators carousel-indicators-bullet" *ngIf="showIndicators">
      @for (idx of slideIndexes; track idx; let i = $index) {
        <li
          [attr.data-bs-target]="'#' + carouselId"
          [attr.data-bs-slide-to]="i"
          class="ms-1"
          [class.active]="i === 0"
        ></li>
      }
    </ol>
  </div>

  <div class="carousel-inner pt-4">
    @for (i of slideIndexes; track i) {
      <div class="carousel-item" [class.active]="i === 0">
        <div class="row g-3 justify-content-center">
          @for (item of sliceFor(i); track item.imageUrl) {
            <div class="col-12 col-md-4">
              <div class="card border-0 shadow-sm h-100">
                <img [src]="item.imageUrl" [alt]="item.alt || item.title" class="card-img-top rounded-top" />
                <div class="card-body text-center" *ngIf="item.title || item.text">
                  <h6 class="fw-semibold mb-1">{{ item.title }}</h6>
                  <p class="small text-muted m-0">{{ item.text }}</p>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <button
    *ngIf="showControls"
    class="carousel-control-prev"
    type="button"
    [attr.data-bs-target]="'#' + carouselId"
    data-bs-slide="prev"
  >
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">{{ 'common.previous' | translate }}</span>
  </button>
  <button
    *ngIf="showControls"
    class="carousel-control-next"
    type="button"
    [attr.data-bs-target]="'#' + carouselId"
    data-bs-slide="next"
  >
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">{{ 'common.next' | translate }}</span>
  </button>
</div>
